<!-- 汇率查询 -->
<template>
  <div class="monthCashBalance">
    <sirui-search
      ref="siruiSearch"
      :query="searchForm"
      :columns="searchColumns"
      @searchCompanyChange="searchCompanyChange"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    >
    </sirui-search>
    <!-- 表格 -->
    <div class="main-content">
      <vxe-toolbar v-if="menuButtonList && menuButtonList.length > 0">
        <template v-slot:buttons>
          <template v-for="item in menuButtonList">
            <vxe-button
              type="primary"
              :icon="item.attributes.buttonStyle"
              :style="
                'background-color:' +
                (item.label == '删除' || item.label == '禁用' ? '#FE8783' : 'rgb(98, 153, 254)') +
                ';border:1px solid ' +
                (item.label == '删除' || item.label == '禁用' ? '#FE8783' : 'rgb(98, 153, 254)')
              "
              :key="item.id"
              @click="chooseClick(item.attributes.buttonUrl, item)"
              >{{ item.label }}</vxe-button
            >
          </template>
        </template>
      </vxe-toolbar>
      <vxe-grid
        border
        show-overflow
        resizable
        ref="table"
        class="vxe-table-element"
        size="mini"
        align="left"
        min-width="120"
        :loading="load"
        :auto-resize="true"
        :data="tableData"
        :columns="columnList"
        :edit-rules="rules"
        :edit-config="{ trigger: 'click', mode: 'row' }"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
        @edit-actived="editActivedEvent"
        :max-height="$store.state.app.tableHeight"
      >
      </vxe-grid>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          ref="page"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-count="page.pages"
          :page-size="page.pageSize"
          :total="page.total"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>
    <sirui-upload
      :action="action"
      @getData="getData"
      ref="SiruiUpload"
      :data="token"
    ></sirui-upload>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { addRules } from './rules.js'; // 校验规则
  import API from '@/api/capitalCenter/moneyDraw';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiUpload from '@/components/SiruiUpload';
  import XEUtils from 'xe-utils';
  import baseUrl from '@/common/config';
  // import COM_API from '@/api/masterData/company.js';
  // import InputNumber from '@/components/form-item/input-number';
  export default {
    name: 'monthCashBalance',
    components: {
      SiruiSearch,
      SiruiUpload,
      // InputNumber,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      token() {
        return {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
        };
      },
      searchColumns() {
        return [
          {
            // 业务公司
            name: this.$t('monthCashBalance.column.businessCompany'),
            prop: 'businessCompanyCode',
            type: 'select',
            options: this.companyList,
            changeMethod: 'searchCompanyChange',
            filterable: true,
          },
          {
            // 业务部门
            prop: 'businessDepartmentCode',
            name: this.$t('monthCashBalance.column.businessDepartment'),
            type: 'select',
            options: this.searchDepartmentList,
            filterable: true,
          },
          {
            // 年度
            name: this.$t('monthCashBalance.column.fundYear'),
            prop: 'fundYear',
            type: 'year',
            format: 'yyyy',
          },
          {
            // 月份
            name: this.$t('monthCashBalance.column.fundMonth'),
            prop: 'fundMonth',
            type: 'select',
            options: this.monthList,
            filterable: true,
          },
        ];
      },
      //基础数据表单配置
      columnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            field: 'businessCompanyCode',
            title: this.$t('monthCashBalance.column.businessCompany'),
            editRender: {
              name: 'ElSelect',
              options: this.companyList,
              props: {
                clearable: true,
                filterable: true,
              },
              events: { change: this.companyChange },
            },
          },
          {
            field: 'businessDepartmentCode',
            title: this.$t('monthCashBalance.column.businessDepartment'),
            formatter: this.formatDepartLabel,
            editRender: {
              name: 'ElSelect',
              options: this.departmentList,
              props: {
                clearable: true,
                filterable: true,
              },
              events: { change: this.departmentChange },
            },
          },
          {
            field: 'fundYear',
            title: this.$t('monthCashBalance.column.fundYear'),
            editRender: {
              name: 'ElDatePicker',
              props: {
                clearable: true,
                type: 'year',
                valueFormat: 'yyyy',
              },
            },
          },
          {
            field: 'fundMonth',
            title: this.$t('monthCashBalance.column.fundMonth'),
            editRender: {
              name: 'ElSelect',
              options: this.monthList,
              props: {
                clearable: true,
                filterable: true,
              },
            },
          },
          {
            field: 'fundBalanceBeginning',
            title: this.$t('monthCashBalance.column.fundBalanceBeginning'),
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row.fundBalanceBeginning}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row.fundBalanceBeginning}
                    max={999999999.999999}
                    min={-999999999}
                    precision={6}
                    onInput={(val) => this.chooseTable(val, row, 'fundBalanceBeginning')}
                  ></input-number>,
                ];
              },
            },
          },
        ];
      },
    },
    data() {
      return {
        heightNew: 0,
        companyList: [],
        departmentList: [],
        searchDepartmentList: [],
        action: API.IMPORT_CASHBALANCE,
        monthList: [
          { label: '一月', value: 1 },
          { label: '二月', value: 2 },
          { label: '三月', value: 3 },
          { label: '四月', value: 4 },
          { label: '五月', value: 5 },
          { label: '六月', value: 6 },
          { label: '七月', value: 7 },
          { label: '八月', value: 8 },
          { label: '九月', value: 9 },
          { label: '十月', value: 10 },
          { label: '十一月', value: 11 },
          { label: '十二月', value: 12 },
        ],
        menuButtonList: [], // 按钮
        load: false,
        tableData: [],
        multipleSelection: [],
        searchForm: {
          businessCompanyCode: null,
          businessDepartmentCode: null,
          fundYear: null,
          fundMonth: null,
        },
        page: {
          pages: 0,
          pageSize: 10,
          pageNum: 1,
          total: 0,
        },
        rules: addRules,
      };
    },
    mounted() {
      this.getData();
      this.getButtonList();
      this.getCompany();
      this.heightNew = document.body.clientHeight - 300 + 'px';
    },
    methods: {
      chooseTable(val, row, prop) {
        row[prop] = val;
      },
      companyChange(val) {
        val.row.businessCompanyName = val.row.businessCompanyCode
          ? this.companyList.find((item) => item.value == val.row.businessCompanyCode).label
          : null;
        val.row.businessDepartmentCode = null;
        this.getDepartment(val.row.businessCompanyCode, 'departmentList');
      },
      searchCompanyChange(val) {
        // 切换公司
        this.searchForm.businessDepartmentCode = null;
        this.getDepartment(val.val, 'searchDepartmentList');
      },
      async getDepartment(companyCode, departmentListName) {
        // 获取部门数据
        if (companyCode) {
          let res = await this.$baseRequest.getDepartment(companyCode);
          if (res) {
            this[departmentListName] = res;
          }
        } else {
          this[departmentListName] = [];
        }
      },
      departmentChange(val) {
        val.row.businessDepartmentName = this.departmentList.find(
          (item) => item.value == val.row.businessDepartmentCode
        ).label;
      },
      formatDepartLabel({ row }) {
        return row.businessDepartmentName ? row.businessDepartmentName : '';
      },
      editActivedEvent({ row }) {
        if (row.businessCompanyCode) {
          this.getDepartment(row.businessCompanyCode, 'departmentList');
        } else {
          this.departmentList = [];
        }
      },
      async getData() {
        this.load = true;
        const [pageNum, pageSize] = [this.page.pageNum, this.page.pageSize];
        const params = { ...this.searchForm, pageNum, pageSize };
        let res = await this.$axios.post(API.QUERY_CASHBALANCE_PAGE, params);
        if (res) {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.tableData.map((item) => {
              item.fundYear = item.fundYear.toString();
            });
            this.page.total = res.data.data.total;
          }
        }
      },
      //公司代码
      async getCompany() {
        let res = await this.$baseRequest.getCompanyList();
        if (res) {
          this.companyList = res;
        }
      },
      chooseClick(value) {
        if (value === 'add') {
          this.handleAdd();
        } else if (value === 'edit') {
          this.handleEdit();
        } else if (value === 'save') {
          this.handleSave();
        } else if (value == 'export') {
          this.handleExport();
        } else if (value == 'import') {
          this.$refs.SiruiUpload.dialogUpload = true;
        } else if (value == 'del') {
          this.handleDel();
        }
      },
      // 跳转至新增页面
      handleAdd() {
        let path = {
          path: '/moneyDraw/monthCashBalanceAdd',
          name: 'monthCashBalanceAdd',
          meta: {
            keepAlive: true,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 编辑
      handleEdit() {
        let selectRecords = this.$refs.table.getCheckboxRecords();
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.forEach((item) => {
            this.$refs.table.setActiveRow(item);
          });
          this.$refs.table.validate(selectRecords).catch((errMap) => errMap); //修改校验
        } else {
          this.$message({
            showClose: true,
            message: this.$t('monthCashBalance.message.select'),
            type: 'error',
          });
        }
      },
      async handleSave() {
        let res = await this.exportChildData();
        if (res) {
          let params = {
            ...res,
          };
          this.saveData(params);
        }
      },
      async saveData(params) {
        this.loading.startLoading();
        let res = await this.$axios.post(API.SAVE_CASHBALANCE, params);
        if (res) {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              type: 'success',
              message: res.data.msg,
            });
            this.resetBtnClick();
          } else {
            this.$message({
              showClose: true,
              type: 'error',
              message: res.data.msg,
            });
          }
        }
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((res) => {
          this.menuButtonList = res;
        });
      },
      // 选中事件
      handleSelectionChange(val) {
        this.multipleSelection = val.selection;
      },
      searchBtnClick() {
        this.resetBtnClick();
      },
      // 重置
      resetBtnClick() {
        this.page.pages = 0;
        this.page.pageSize = 10;
        this.page.pageNum = 1;
        this.page.total = 0;
        this.getData();
      },
      handleSizeChange(value) {
        this.page.pageSize = value;
        this.getData();
      },
      handleCurrentChange(value) {
        this.page.pageNum = value;
        this.getData();
      },
      // 删除/撤销弹框
      handleDel() {
        if (this.multipleSelection.length == 0) {
          return this.tips('noSelected');
        }
        let ids = [];
        this.multipleSelection.map((item) => {
          ids.push(item.id);
        });
        this.$confirmAction()
          .then(() => {
            this.del(ids);
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      // 删除/撤销
      del(ids) {
        const params = {
          ids,
        };
        this.$axios.post(API.DELETE_CASHBALANCE, params).then((res) => {
          if (0 == res.data.code) {
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
            this.resetBtnClick();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 返回数据
      exportChildData() {
        const tableData = this.$refs.table.getTableData().fullData;
        return new Promise((resolve) => {
          this.$refs.table.validate((valid) => {
            if (valid) {
              let param = {
                list: tableData,
              };
              resolve(param);
            }
          });
        });
      },
      //导出功能
      handleExport() {
        const selectedList = this.$refs.table.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = '';
          // let ids = changeList.forEach((item) => {
          //   str += 'ids=' + item.id + '&';
          // });
          // let params = {
          //   ids: JSON.stringify(ids),
          //   access_token: this.token.access_token,
          // };
          window.location.href = `${baseUrl}${API.EXPORT_CASHBALANCE}?${str}access_token=${this.token.access_token}`;
        } else {
          const params = XEUtils.serialize(this.searchForm);
          window.location.href = `${baseUrl}${API.EXPORT_CASHBALANCE}?${params}&access_token=${this.token.access_token}`;
        }
      },
      // 提示
      tips(info) {
        this.$message({
          showClose: true,
          message: this.$t(`monthCashBalance.message.${info}`),
          type: 'error',
        });
      },
    },
  };
</script>
